import { FC } from 'react';
import { Headline, Subheadline, Caption, Button } from '@telegram-apps/telegram-ui';
import { useTranslation } from 'react-i18next';
import { TbAlertTriangle } from 'react-icons/tb';
import {haptic} from "@/helpers/haptic.ts";

interface OrganizerWarningProps {
  onConfirm: () => void;
  onCancel: () => void;
}

export const OrganizerWarning: FC<OrganizerWarningProps> = ({ onConfirm, onCancel }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-6 p-6">
      <div className="flex flex-col items-center gap-4 text-center">
        <TbAlertTriangle size={64} className="text-color-hint" />
        <Headline weight="2">{t('secretSanta.warning.title')}</Headline>
        <Subheadline level="2" className="text-color-hint">
          {t('secretSanta.warning.description')}
        </Subheadline>
      </div>

      <div className="flex flex-col gap-2 p-4 bg-section rounded-lg">
        <Caption className="flex items-start gap-2">
          <span>•</span>
          <span>{t('secretSanta.warning.responsibility1')}</span>
        </Caption>
        <Caption className="flex items-start gap-2">
          <span>•</span>
          <span>{t('secretSanta.warning.responsibility2')}</span>
        </Caption>
        <Caption className="flex items-start gap-2">
          <span>•</span>
          <span>{t('secretSanta.warning.responsibility3')}</span>
        </Caption>
      </div>

      <div className="flex flex-col gap-3">
        <Button stretched={true} onClick={() => {
          haptic.notification('warning');
          onConfirm();
        }} mode="filled">
          {t('secretSanta.warning.confirm')}
        </Button>
        <Button stretched={true} onClick={() => {
          onCancel();
        }} mode="plain">
          {t('action.cancel')}
        </Button>
      </div>
    </div>
  );
};
